import script from "./SegmentedToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentedToggle.vue?vue&type=script&setup=true&lang=js"

import "./SegmentedToggle.vue?vue&type=style&index=0&id=3da51fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da51fa0"]])

export default __exports__